import 'core-js/modules/es.symbol';
import 'core-js/modules/es.symbol.description';
import 'core-js/modules/es.symbol.to-primitive';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.date.to-primitive';
import 'core-js/modules/es.function.name';
import 'core-js/modules/es.number.constructor';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.to-string';
import React, { Component } from 'react';
import { assert, assertType } from 'yaassertion';
import { MessageFormat } from '@paypalcorp/worldready-message';
import { WorldReady, isWorldReadyInstance } from '@paypalcorp/worldready-core';
import hoistNonReactStatic from 'hoist-non-react-statics';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["children", "id", "namespace", "variables", "source"];
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Context = React.createContext();
var ContextProvider = function ContextProvider(_ref) {
  var locale = _ref.locale,
    children = _ref.children;
  var worldReady = new WorldReady(locale);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: worldReady
  }, children);
};
var ContextConsumer = Context.Consumer;
var DOCUMENTATION_HOMEPAGE = "https://github.paypal.com/pages/Globalization-R/worldready-js/docs";
var MessageParts = function MessageParts(_ref2) {
  var messageParts = _ref2.messageParts;
  return /*#__PURE__*/React.createElement(React.Fragment, null, messageParts.map(function (_ref3, i) {
    var type = _ref3.type,
      value = _ref3.value,
      children = _ref3.children,
      variableName = _ref3.variableName;
    if (type === "variable-block") {
      var ret = value( /*#__PURE__*/React.createElement(MessageParts, {
        messageParts: children
      }));
      if (process.env.NODE_ENV !== "production") {
        assert(React.isValidElement(ret), "Variable {{variableName}} should return a react element, not {{ret}}", {
          variableName: variableName,
          ret: ret
        });
      }
      return React.cloneElement(ret, Object.assign({
        key: i
      }, value.props));
    }
    if (React.isValidElement(value)) {
      return React.cloneElement(value, Object.assign({
        key: i
      }, value.props));
    }
    return value;
  }));
};
var Message = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Message, _Component);
  function Message() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Message.prototype;
  _proto.render = function render() {
    if (process.env.NODE_ENV !== "production") {
      assert(typeof this.props !== "string", "Message function got a String, but expected an Object. Did you mean { id: \"" + this.props + "\"} instead?");
    }
    var _this$props = this.props,
      children = _this$props.children,
      id = _this$props.id,
      namespace = _this$props.namespace,
      variables = _this$props.variables,
      source = _this$props.source,
      otherProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    if (process.env.NODE_ENV !== "production") {
      // 1: There are cases where empty elements are coming as empty array []
      // children, so need to check for length as well. At present we did not
      // identify the cause, it could be related to react version or due to preact.
      // Not able to reproduce this in unit tests ¯\_(ツ)_/¯
      assert(!children || !children.length /* 1 */, "Message must be an empty element (no children)");
      assertType(id, "id", ["array", "string"]);
      if (namespace) {
        assertType(namespace, "namespace", ["array", "string"]);
      }
    }
    var worldReady = this.context;
    if (process.env.NODE_ENV !== "production") {
      assert(isWorldReadyInstance(worldReady), "Missing worldReady object. Please read " + DOCUMENTATION_HOMEPAGE + "/about-get-started.html#reactjs");
    }
    var messageFmt = new MessageFormat(worldReady, {
      id: id,
      source: source,
      namespace: namespace
    });

    // If message is instance of ContentMessage:
    var _variables = variables || otherProps;

    // TODO cache formatted message, see react-globalize for reference.
    return /*#__PURE__*/React.createElement(MessageParts, {
      messageParts: messageFmt.formatToParts(_variables)
    });
  };
  return Message;
}(Component);
_defineProperty(Message, "contextType", Context);
function getDisplayName(Component) {
  return Component.displayName || Component.name || "Component";
}
function injectWorldReady(WrappedComponent) {
  var InjectWorldReady = /*#__PURE__*/function (_Component2) {
    _inheritsLoose(InjectWorldReady, _Component2);
    function InjectWorldReady() {
      return _Component2.apply(this, arguments) || this;
    }
    var _proto2 = InjectWorldReady.prototype;
    _proto2.render = function render() {
      var _this = this;
      return /*#__PURE__*/React.createElement(ContextConsumer, null, function (worldReady) {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, _this.props, {
          worldReady: worldReady,
          griffin: worldReady
        }));
      });
    };
    return InjectWorldReady;
  }(Component); // Why this? https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
  // Why this? https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
  _defineProperty(InjectWorldReady, "displayName", "InjectWorldReady(" + getDisplayName(WrappedComponent) + ")");
  _defineProperty(InjectWorldReady, "WrappedComponent", WrappedComponent);
  hoistNonReactStatic(InjectWorldReady, WrappedComponent);
  return InjectWorldReady;
}
var injectGriffin = injectWorldReady;

export { Context, ContextConsumer, ContextProvider, Message, injectGriffin, injectWorldReady };
